// extracted by mini-css-extract-plugin
export default {"headerActionBtn":"header_headerActionBtn__g1pI6","arrowLeftIcon":"header_arrowLeftIcon__JgErj","headerText":"header_headerText__fQPmW"};